const { send: ajax } = require('client/lib/request')
const { track } = require('client/lib/analytics')
const { alert, confirm } = require('client/components/confirm')

function actionsButtons() {
  return [
    { label: 'Report this user', value: 'report' },
    { label: 'Cancel', value: '' }
  ]
}

function reportUser({ reportedUser, reporterUser, pageContext }) {
  return ajax({
    url: '/api/v0.1/reports/user',
    method: 'post',
    data: {
      context: 'flag',
      'reported_id': reportedUser.id,
      'page_context': pageContext
    }
  })
  .then(() =>
    track('report-user', {
      'reported_id': reportedUser.id,
      'reporter_id': reporterUser.id,
      metabase: {
        'actioned_object_type': 'report',
        'actioned_object_id': reportedUser.id
      },
      'page_context': pageContext
    })
  )
  .then(() => alert({
    heading: 'User Reported',
    subheading: 'Got it - thanks for letting us know!'
  }))
}

function confirmUserAction(options) {
  return confirm({
    heading: 'Actions for this User',
    buttons: actionsButtons(),
    closeOnBackdropClick: true
  })
  .then(action => {
    switch (action) {
      case 'report':
        return reportUser(options)
    }
  })
}

module.exports = {
  confirmUserAction,
  reportUser
}
